import { Partner } from '../config/AppConfig';
import { Fetch } from '../components';


export const Mt5Service = {
  /**
  * [GetGroupsByCompanyId]
  */
  GetGroupsByCompany( companyId) {
    const requestOptions = {
      method: 'GET',
      headers: Partner.utilities.authorizedHeader(),
    };

    return Fetch(`${Partner.service.mt5.getGroupsById}/${companyId}`, requestOptions);
  },
  /** Get Group Symbols by group name*/
  GetGroupSymbolsByGroupName(group) {
    const requestOptions = {
      method: 'GET',
      headers: Partner.utilities.authorizedHeader(),
    };

    return Fetch(`${Partner.service.mt5.getGroupSymbolsByGroup}?group=${group}`, requestOptions);
  },
};
